import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import {
  required,
  email,
  length,
  alpha_num,
  between,
  max,
  min_value,
  min
} from "vee-validate/dist/rules";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

extend("min_value", {
  ...min_value,
  message: "Minimum value is 1"
});

extend("min", {
  ...min,
  message: "Minimum value is 4"
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("email", {
  ...email,
  message: "Invalid email format"
});

extend("loc_id_length", {
  ...length,
  message: "15 characters required"
});

extend("contact_no_length", {
  ...length,
  message: "10 digits required"
});

extend("alpha_num", {
  ...alpha_num,
  message: "Alpha numeric only"
});

extend("max", {
  ...max,
  message: "Should not exceed maximum character limit"
});

extend("between", {
  ...between,
  message: "Value should be between -180.999999 and 180.999999"
});

extend("noSpecialChars", {
  message:
    "Radius username must only be alphanumeric and may contain '@', '_' and '.' characters. No spaces allowed.",
  validate: val =>
    /^[a-zA-Z0-9@_.\-]*$/.test(val) || /^[^@][a-zA-Z0-9@_.]*$/.test(val)
});

extend("radiusUsername", {
  message: "Radius username format invalid",
  validate: val =>
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+@[a-zA-Z0-9]+$/.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}$/.test(
      val
    ) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}(?:\.[a-zA-Z0-9]{2,})+$/i.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}(?:\.[a-zA-Z0-9]{2,})+$/i.test(
      val
    )
});

extend("vlanValue", {
  ...between,
  message: "Value should be between 2 and 4004"
});

extend("custRefLength", {
  validate: value =>
    new Promise(resolve => {
      resolve({
        valid: value.length <= 20
      });
    }),
  message: "{_field_} should not exceed 20 characters"
});

extend("locationId", {
  validate: value =>
    new Promise(resolve => {
      const isLocId = /^LOC/;
      resolve({
        valid: isLocId.test(value)
      });
    }),
  message: "Invalid {_field_}"
});

extend("custRef", {
  validate: value =>
    new Promise(resolve => {
      resolve({
        valid: parseInt(value) !== 0
      });
    }),
  message: "Invalid {_field_}"
});

extend("isFirstCharValid", {
  validate: value =>
    new Promise(resolve => {
      const isValid = new RegExp("^[a-zA-Z0-9]");
      resolve({
        valid: isValid.test(value)
      });
    }),
  message: "{_field_} not allowed to start with a special character"
});

const PhoneNumber = require("awesome-phonenumber");

extend("phonenumber", {
  validate: value =>
    new Promise(resolve => {
      const pn = new PhoneNumber(value, "AU");
      const isNumber = /^[0-9]*$/;
      resolve({
        valid: (pn.isValid() || pn.isMobile()) && isNumber.test(value)
      });
    }),
  message: "{_field_} is not a valid mobile number"
});

extend("custcontactnumber", {
  validate: value =>
    new Promise(resolve => {
      const pn = new PhoneNumber(value, "AU");
      const isNumber = /^[0-9]*$/;
      const invalidNumber = new RegExp(`^${1}`);
      const isValidLength = /^\d{10}$/;
      resolve({
        valid:
          (pn.isValid() || pn.isMobile()) &&
          isNumber.test(value) &&
          !invalidNumber.test(value) &&
          isValidLength.test(value)
      });
    }),
  message: "{_field_} is not a valid number."
});

extend("rateplanId", {
  message: "{_field_} is required.",
  validate: value => value > 0
});

extend("locationValidator", {
  validate: value => {
    if (/^\d+$/.test(value)) return false;
    return true;
  },
  message: "Please enter a valid address."
});

extend("appointmentValidation", {
  validate: value => {
    return value !== null && value !== "No" && value !== "";
  },
  message: "Appointment is required"
});

extend("avcFormat", value => {
  if (!value) {
    return "This field is required";
  }

  const avcPattern = /^AVC\d{12}$/;
  if (!avcPattern.test(value)) {
    return "Invalid AVC format";
  }

  return true;
});
